import { BulkActionsVariant, BulkEntityActionItem } from "components/BulkActions/types";

import { ApiKeyRolesMutationVariables } from "./useApiKeyRolesBulkActions/types";
import { ApiKeyViewRoleBinding } from "../../types";

export enum ApiKeyRolesBulkActions {
  Delete = "Delete",
}

export type ApiKeyRolesBulkActionsAnalyticsPayload = {
  view: BulkActionsVariant;
  metadata: Record<string, string | boolean>;
};

export type ApiKeyRolesBulkActionsSelectedAction = BulkEntityActionItem<
  ApiKeyRolesBulkActions,
  ApiKeyViewRoleBinding,
  ApiKeyRolesMutationVariables
>;